import { render } from "./Outcome.vue?vue&type=template&id=021f06a1&scoped=true&ts=true"
import script from "./Outcome.vue?vue&type=script&lang=ts"
export * from "./Outcome.vue?vue&type=script&lang=ts"

import "./Outcome.vue?vue&type=style&index=0&id=021f06a1&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021f06a1"]])

export default __exports__